<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import customizeStyle from '../../../customize.json'

/**
 * 画面仕様書
 *
 * 機能名　  : ログイン機能
 * 画面ＩＤ  : MLO-0800
 * 画面名　  : スプラッシュ画面
 * 概要　　  : 起動時に表示する画面
 */
@Component
export default class MLO_0800 extends Vue {
  primary: object = customizeStyle.header.primary

  constructor() {
    super()
  }
}
</script>

<template>
  <v-layout class="px-4" column fill-height id="mlo-0800" justify-center align-center>
    <v-spacer/>
    <img
        class="mb-5"
        :src="primary.icon"
        :style="{
            width: primary.width,
            height: primary.height,
          }"
        alt=""
    />
    <v-progress-circular
        class="absolute-center"
        color="primary"
        indeterminate
    />
    <v-spacer/>
  </v-layout>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//
</style>
